

















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptPurchaseDeliverySchedule extends Vue {

  // 出荷予定表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public deliveryDateFrom: Date = null;
  public deliveryDateTo: Date = null;
  public segment: Common.Segment = null;
  public warehouse: Common.Counterpart = null;
  public noneScheduledFlag: boolean = false;
  public onExcelExport :boolean = false;
  public deliveryDateFromFlag : Common.dateFlags = Common.dateFlags.default;
  public deliveryDateToFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){    
      var query: Common.PurchaseDeliveryScheduleReportTemplateQuery = new Common.PurchaseDeliveryScheduleReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    this.noneScheduledFlag = true;
    this.deliveryDateFrom = new Date().getCalendarDate();
    this.deliveryDateTo = new Date().getCalendarDate();
    (this.$refs.PurchaseDeliveryScheduleDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.PurchaseDeliveryScheduleReportQuery = new Common.PurchaseDeliveryScheduleReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.segment = this.segment;
    query.warehouse = this.warehouse;
    query.deliveryDateFrom = this.deliveryDateFrom;
    query.deliveryDateTo = this.deliveryDateTo;
    query.noneScheduledFlag = this.noneScheduledFlag;
    query.salesPurchaseFlag = 0;
    query.onExcelExport = this.onExcelExport;    
   this.$api.download(query);
  }
}
